import React, { Component } from 'react'
import { ModalHeader, ModalFooter, ModalBody, Button } from 'reactstrap'

export default class LiverFrailtyCalculator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gripAttempt1Kg: '',
      gripAttempt2Kg: '',
      gripAttempt3Kg: '',
      chairStandsSec: '',
      SideSec: '',
      SemiTandemSec: '',
      TandemSec: '',
      gender: '',
    }
  }

  render() {
    const { gender, chairStandsSec } = this.state

    const gripSamples = [1, 2, 3].map((a) => this.state[`gripAttempt${a}Kg`])
    const gripAvg = Math.round((gripSamples.reduce((sum, a) => sum + a, 0) / 3) * 10) / 10

    const balances = ['Side', 'SemiTandem', 'Tandem']
    const balanceSamples = balances.map((a) => this.state[`${a}Sec`])
    const balanceSum = Math.min(
      30,
      balanceSamples.reduce((sum, a) => sum + a, 0)
    )

    const filled =
      gender !== '' &&
      chairStandsSec > 0 &&
      gripSamples.every((s) => s > 0) &&
      balanceSamples.every((s) => s > 0)

    // pulled from https://liverfrailtyindex.ucsf.edu/js/app.js
    const gripAvgAdjusted =
      gender === 'male' ? (gripAvg - 34.175) / 9.976 : (gripAvg - 21.863) / 6.312

    let result = -0.33 * gripAvgAdjusted + (-2.529 * 5.0) / chairStandsSec + -0.04 * balanceSum + 6
    result = Math.round(result * 100) / 100

    return (
      <div className="LiverFrailtyCalculator">
        <ModalHeader toggle={this.onDismissModal}>Liver Frailty Index Calculator</ModalHeader>
        <ModalBody>
          <div>
            <h6>Gender:</h6>
            <div style={{ display: 'flex' }}>
              <div className="form-check">
                <input
                  id={`gender-male`}
                  className="form-check-input"
                  type="radio"
                  checked={gender === 'male'}
                  onChange={(e) => this.setState({ gender: 'male' })}
                />
                <label htmlFor="gender-male" className="form-check-label">
                  Male
                </label>
              </div>
              <div className="form-check" style={{ marginLeft: 20 }}>
                <input
                  id={`gender-female`}
                  className="form-check-input"
                  type="radio"
                  checked={gender === 'female'}
                  onChange={(e) => this.setState({ gender: 'female' })}
                />
                <label htmlFor="gender-female" className="form-check-label">
                  Female
                </label>
              </div>
            </div>
            <h6>Dominant hand grip strength (kg):</h6>
            <div style={{ display: 'flex' }}>
              {[1, 2, 3].map((idx) => (
                <div key={idx} className="attempt">
                  attempt {idx}
                  <input
                    className="form-control"
                    type="number"
                    value={this.state[`gripAttempt${idx}Kg`]}
                    onChange={(e) => this.setState({ [`gripAttempt${idx}Kg`]: e.target.value / 1 })}
                  />
                </div>
              ))}
              <div key="avg" style={{ flex: 1 }}>
                Avg:
                <input className="form-control" type="number" value={gripAvg} readOnly />
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 30 }}>
              <h6 style={{ flex: 1, margin: 0 }}>Time to do 5 chair stands (sec):</h6>

              <input
                className="form-control"
                type="number"
                value={chairStandsSec}
                style={{ width: 100 }}
                onChange={(e) => this.setState({ chairStandsSec: e.target.value / 1 })}
              />
            </div>
            <h6>Seconds holding 3 position balance:</h6>
            <div style={{ display: 'flex' }}>
              {balances.map((balance) => (
                <div key={balance} className="attempt">
                  {balance}
                  <input
                    className="form-control"
                    type="number"
                    value={this.state[`${balance}Sec`]}
                    onChange={(e) => this.setState({ [`${balance}Sec`]: e.target.value / 1 })}
                  />
                </div>
              ))}
              <div key="avg" style={{ flex: 1 }}>
                Total:
                <input className="form-control" type="number" value={balanceSum} readOnly />
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 30 }}>
              <h6 style={{ flex: 1, margin: 0 }}>Result:</h6>
              <div style={{ textAlign: 'right' }}>
                <strong>{filled ? result : 'Fill in all of the fields above.'}</strong>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={!filled} onClick={() => this.props.onChange(result)}>
            Use This Score
          </Button>
        </ModalFooter>
      </div>
    )
  }
}
